import React, { useRef} from 'react';
import '../../App.css';
import { Button } from '../Button';
import { Link } from 'react-router-dom';

export default function Landingpage(props) {
  let landingpage = useRef(null)


  return (<div className='products' ref={landingpage}>
            <div className='text'>The information collected is confidential and intended solely for the use of this study. We will not, in any circumstances, share your business information with other individuals or organizations without your permission, including public organizations, corporations or individuals. We do not sell, communicate or divulge any information.
            <div></div><br></br>Les informations recueillies sont confidentielles et destinées uniquement à l'usage de cette étude. Nous ne partagerons en aucun cas vos informations commerciales avec d'autres personnes ou organisations sans votre autorisation, y compris des organisations publiques, des sociétés ou des particuliers. Nous ne vendons, ne communiquons ni ne divulguons aucune information.
            <div></div><br></br>
            <div style={{textAlign:'center'}}className='hero-btns'>
                    <Button
                      className='btns'
                      buttonStyle='btn--outline'
                      buttonSize='btn--large'
                    >
                      <Link
                        to='/English'
                        className='nav-links'
                      >
                        English
                      </Link>
                    </Button>
                    
                    <Button
                      className='btns'
                      buttonStyle='btn--outline'
                      buttonSize='btn--large'
                    >
                      <Link
                        to='/French'
                        className='nav-links'
                      >
                        Français
                      </Link>
                    </Button>
                    <div><br></br></div>
                    <Button
                      className='btns'
                      buttonStyle='btn--outline'
                      buttonSize='btn--large'
                    >
                      <a
                        href='https://ee.kobotoolbox.org/x/SmkHq70F'
                        className='nav-links'
                      >
                        Mobile English
                      </a>
                    </Button>
                    <Button
                      className='btns'
                      buttonStyle='btn--outline'
                      buttonSize='btn--large'
                    >
                      <a
                        href='https://ee.kobotoolbox.org/x/SmkHq70F?lang=fr'
                        className='nav-links'
                      >
                        Mobile Français
                      </a>
                    </Button>
            </div>
            
            </div>
            
          </div>);
}
